import { useFlag } from '@calendly/feature-check-react'

import { useProductRefreshAppShell } from 'features/app_shell/product_refresh/useProductRefreshAppShell'
import {
  getMeetingsUserMePath,
  getVideoLocationKinds,
  getVideoLocationTypes,
  useNotetakerEntitled,
} from 'features/meeting_intelligence'
import { useNotetakerFreeExperiment } from 'hooks/useNotetakerFreeExperiment'

import { AiBetaBanner } from '../ai_beta_banner'
import { NotetakerBanner } from '../notetaker_banner'
import { TabContainer } from '../styles'
import { AiNotes } from './ai_notes'
import { MeetingNotesForm } from './meeting_notes_form'

export const NotesTab = ({ selectedEvent,
  setTempTab,
  tempTab,
  closeLeavePageModal,
  showLeavePageModal,
  switchToTab,
  miSettings,
  user }) => {
  const { isEntitled: isNotetakerEntitled } = useNotetakerEntitled()
  const hasTeamsFlag = useFlag('ms_teams_notetaker')
  const isProductRefreshAppShell = useProductRefreshAppShell()
  const { isInExperiment: isInNotetakerFreeExperiment } = useNotetakerFreeExperiment()
  const isMeetingsPage = window.location.pathname === getMeetingsUserMePath(isProductRefreshAppShell)

  const eligibleLocationKinds = getVideoLocationKinds(hasTeamsFlag)
  const eligibleLocationTypes = getVideoLocationTypes(hasTeamsFlag)
  const isEligibleMeeting = eligibleLocationKinds.includes(selectedEvent?.locationKind)
    || eligibleLocationTypes.includes(selectedEvent?.locationType)
  const isFutureMeeting = !selectedEvent.past

  const showAiNotes = isNotetakerEntitled && !isFutureMeeting && isMeetingsPage
  const meetsBaseBannerCriteria = isFutureMeeting && isEligibleMeeting
  const showNotetakerBanner = meetsBaseBannerCriteria
    && ((isNotetakerEntitled && !!miSettings?.miEnabled) || isInNotetakerFreeExperiment)
  const showBetaBanner = isNotetakerEntitled
    && isFutureMeeting
    && !miSettings?.miEnabled
    && isEligibleMeeting
    && !isInNotetakerFreeExperiment

  return (
    <TabContainer>
      <MeetingNotesForm
        event={selectedEvent}
        setTempTab={setTempTab}
        tempTab={tempTab}
        closeLeavePageModal={closeLeavePageModal}
        showLeavePageModal={showLeavePageModal}
        switchToTab={switchToTab}
        location="meetings_page_right_rail"
        miEventUuid={selectedEvent.meetingIntelligence?.uuid}
      />
      {showAiNotes && <AiNotes event={selectedEvent} />}
      {showNotetakerBanner && (
        <NotetakerBanner
          event={selectedEvent}
          user={user}
          isInNotetakerFreeExperiment={isInNotetakerFreeExperiment}
        />
      )}
      {showBetaBanner && <AiBetaBanner userHasEnabledMiBefore={!!miSettings?.userHasEnabledMiBefore} user={user} />}
    </TabContainer>
  )
}
